import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Table from 'react-bootstrap/Table';
import { FaEye, FaPencilAlt, FaTrash } from 'react-icons/fa';

import ContactAPI from '../../api/ContactAPI';
import ApiUiController from '../../controller/ApiUiController';
import Display from '../../util/Display';
import Util from '../../util/Util';
import Const from '../../util/Constants';

class InnerContactList extends React.Component {

  static Contact = 'contact';

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).contact;
    this.state = { inApiCall: true, contacts: [] };

    this.Update = Util.isAllow(this.model.permission, Const.PermUpdate);
    this.Delete = Util.isAllow(this.model.permission, Const.PermDelete);
  }

  componentDidMount() {
    ContactAPI.getInnerList(this.props.type, this.props.id,
      this.onReceived, this.onFail);
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.id !== this.props.id) {
      this.setState({ ...this.state, inApiCall: true, contacts: [] });
      ContactAPI.getInnerList(this.props.type, props.id, this.onReceived, this.onFail);
    }
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = res => {
    if (this.props.onCount) {
      this.props.onCount('contact', res.count);
    }
    if (this.props.onLoad) {
      this.props.onLoad(res.data);
    }
    this.setState({ ...this.state, inApiCall: false, contacts: res.data });
  };
  onDelete = indx => Util.confirmAlert('Delete', 'Are you sure you want to delete',
    'Delete', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      ContactAPI.removeLead(this.state.contacts[indx].pcid, this.onDeleteSuccess, this.onFail);
    });
  onDeleteSuccess = () => {
    Util.showNotification('Successful', 'Contacts deleted successfully', 'success');
    this.props.reload();
  };
  onRemove = indx => Util.confirmAlert('Remove Lead', 'Are you sure you want to delete from  Lead',
    'Remove', 'No', () => {
      this.setState({ ...this.state, inApiCall: true });
      ContactAPI.removeLead(this.state.contacts[indx].id, this.onRemoveSuccess, this.onFail);
    });
  onRemoveSuccess = () => {
    Util.showNotification('Successful', 'Contact removed from lead successfully', 'success');
    this.props.reload();
  };

  showList = () => this.state.contacts.map((contact, _i) => (
    <tr key={`contact_${_i + 1}`}>
      <td>{contact.firstname + ' ' + contact.middlename + ' ' + contact.lastname}</td>
      <td>{Display.FieldValue(contact, 'phone', this.model.fields)}</td>
      <td>{Display.FieldValue(contact, 'email', this.model.fields)}</td>
      <td>
        <span onClick={evnt => this.props.show(contact.id, InnerContactList.Contact)}
          className="buttons add buttons-sm">
          <FaEye /> Details
        </span>
        {this.Update ?
          <span onClick={evnt => this.props.edit(contact.id, InnerContactList.Contact)}
            className="buttons update buttons-sm">
            <FaPencilAlt /> Edit
          </span>
          : null
        }
        {this.Delete ?
          <span onClick={() => this.onDelete(_i)} className="buttons delete buttons-sm"><FaTrash /> Delete</span>
          : null
        }
      </td>
    </tr>
  ));

  render() {
    let uiContact = this.showList();
    if (this.state.contacts.length === 0) uiContact = <tr><td colSpan="8">No Records Found</td></tr>;
    return (
      <div className="row">
        <div className="col-md-12">
          <h2>{this.props.title ? this.props.title : this.model.model_name}</h2>
          <ApiUiController inApiCall={this.state.inApiCall}>
            <Table striped bordered hover >
              <thead>
                <tr><th>Name</th><th>Phone</th><th>Email</th><th className="actionth">Action</th></tr>
              </thead>
              <tbody>
                {uiContact}
              </tbody>
            </Table>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default InnerContactList;